import { render, staticRenderFns } from "./newShelterFee.vue?vue&type=template&id=4010c5af&scoped=true"
import script from "./newShelterFee.vue?vue&type=script&setup=true&lang=js"
export * from "./newShelterFee.vue?vue&type=script&setup=true&lang=js"
import style0 from "./newShelterFee.vue?vue&type=style&index=0&id=4010c5af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4010c5af",
  null
  
)

export default component.exports